import { AccountDeletion } from "./account-deletion";

export default AccountDeletion;
